import { render, staticRenderFns } from "./PopupRegionPicker.vue?vue&type=template&id=74980667&"
import script from "./PopupRegionPicker.vue?vue&type=script&lang=js&"
export * from "./PopupRegionPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports